module.exports = __webpack_public_path__ + "img/level8.d4a5c401.png";